/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kamegeri 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bwama": ["Gitwa", "Kamiro", "Kigarama"],
  "Kamegeri": ["Kinyovu", "Ntaruka", "Rweru", "Sovu"],
  "Kirehe": ["Gasharu", "Kigarama", "Ryanyirataba"],
  "Kizi": ["Gakomeye", "Kagarama", "Kinyana"],
  "Nyarusiza": ["Bande", "Nyarusange", "Nyarusiza", "Rutuna"],
  "Rususa": ["Bahina", "Baro", "Kigarama", "Muhembe"]
};